import { useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';
import useSWR from 'swr';
import { getOTSearchPOSTBody } from 'packages/omnitag/api/get-ot-search-post-body';
import {
  searchQueryAtom,
  allSearchResultsAtom,
} from 'packages/omnitag/state/text-search';
import { omnitagSearchResponseZod } from 'packages/lib/api/omnitag/contract/omnitag-search';
import { useGetFiltersListAPI } from 'packages/omnitag/api/use-get-filters-api';
import { omnitagAPIPost } from 'packages/lib/api/omnitag/rest';

// Aug-11-2025 - Used Gemini 2.5 Agent to make filters dynamic (affected getOTFilterQueryParams)
// Aug-20-2025 - Used Gemini 2.5 Agent to add support for 'number' filters
// Sep-15-2025 - Used Gemini 2.5 Agent to convert from GET to POST

/**
 * Uses params from URL to add appropriate filters.
 */
export const useDoSWRSearchQueriesBasedOnURL = (): void => {
  const filtersSWR = useGetFiltersListAPI();
  const searchQuery = useAtomValue(searchQueryAtom);
  const setResults = useSetAtom(allSearchResultsAtom);

  const searchIsActive = searchQuery && searchQuery.text.length > 0;
  const dynamicFilters = filtersSWR.data?.filters ?? [];

  const swrResult = useSWR(
    searchIsActive
      ? ['/vision/search', getOTSearchPOSTBody(searchQuery, dynamicFilters)]
      : null,
    ([url, body]) => omnitagAPIPost(url, body, omnitagSearchResponseZod.parse),
    { refreshInterval: 0, revalidateOnFocus: false }
  );
  useEffect(() => {
    setResults(swrResult);
  }, [setResults, swrResult]);
};
